import React, { useEffect } from "react";
import useApp from "../../store/app/appContext";
import PageWrapper from "../../containers/app/PageWrapper";
import { useParams, useLocation } from "react-router";
import ScansProvider from "../../store/scans/scansProvider";
import ViewPatientScansDetails from "../../containers/patients/ViewPatientScansDetails";
import AddScan from "../../containers/patients/AddScan";

function PatientScansDetails() {
  const { id } = useParams();
  const location = useLocation();

  const {
    appState: { user },
  } = useApp();
  const [pageTitle, setPageTitle] = React.useState("");

  const addScan = location.pathname.includes("/add");

  useEffect(() => {
    if (id) setPageTitle("Scan details");
    if (addScan) setPageTitle("Add Scan");
  }, []);

  if (!user) return "";
  if (!user._id) return "";

  return (
    <ScansProvider>
      <PageWrapper navbar title={addScan ? 'Add Scan' : 'Scan Details'}>
        {id && <ViewPatientScansDetails scanId={id} />}
        {addScan && <AddScan />}
      </PageWrapper>
    </ScansProvider>
  );
}

export default PatientScansDetails;
